import * as Scheduler from 'scheduler';

const runWithLowPriority = (cb: () => void) =>
  Scheduler.unstable_runWithPriority(Scheduler.unstable_LowPriority, () => {
    cb();
  });

export { runWithLowPriority };
